<div class="top-menu-container" [ngClass]="{'expanded': showMenu }">
    <div class="top-menu-container__button" [ngClass]="{'expanded': showMenu }" (click)="toggleMenu()"></div>
    <div class="top-menu-container__menu" [ngClass]="{'expanded': showMenu }">
        <div class="top-menu-container__menu__header"></div>
        <div class="top-menu-container__menu__content">
            <div *ngFor="let option of MENU_OPTIONS; let i = index" class="top-menu-container__menu__content__option">
                <div class="top-menu-container__menu__content__option__button" (click)="optionClick(i)">
                    <div class="top-menu-container__menu__content__option__button__text">{{ 'top-menu.' + option.text + '.text' | transloco}}</div>
                    <div *ngIf="option.icon" class="top-menu-container__menu__content__option__button__icon">
                        <img [src]="option.icon">
                    </div>
                </div>
                <div *ngIf="subOptionShowing === i && option.suboptions" class="top-menu-container__menu__content__option__suboptions">
                    <div *ngFor="let suboption of option.suboptions"
                        class="top-menu-container__menu__content__option__suboptions__item"
                        (click)="subOptionClick(i, suboption.value)">
                        <ng-container *ngIf="suboption.translate === false; else translatedSuboption">
                          {{ suboption.text }}
                        </ng-container>
                        <ng-template #translatedSuboption>
                          {{ 'top-menu.' + option.text + '.suboptions.' + suboption.text | transloco}}
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
